import { Injectable } from "@angular/core";
import { Planeringsstatus } from "~app/common/models/constants";
import { IAtgard } from "~app/features/planera/model/IAtgard";

@Injectable({
    providedIn: "root"
})
export class AtgardPlaneringsstatusService {

    planeringsstatusarNotYetTillganglig: string[] = [
        Planeringsstatus.UnderPlanering,
        Planeringsstatus.Fardigplanerat
    ];

    isNotYetTillganglig(atgard: IAtgard): boolean {
        return this.planeringsstatusarNotYetTillganglig.includes(atgard.planeringsstatus);
    }

    isNotYetTillgangliga(atgarder: IAtgard[]): boolean {
        return atgarder?.filter(a => this.isNotYetTillganglig(a)).length > 0;
    }
}
